import { useRef } from 'react';

export const useStableReference = <T>(
  value: T,
  areEqual: (previous: T, next: T) => boolean
): T => {
  const ref = useRef(value);

  if (ref.current !== value && !areEqual(ref.current, value)) {
    ref.current = value;
  }

  return ref.current;
};

export const areStringArraysEqual = (
  previous: readonly string[],
  next: readonly string[]
): boolean =>
  previous.length === next.length &&
  previous.every((entry, index) => entry === next[index]);
